import { AxiosResponse } from 'axios'
import api from './Api'

export const cancelTossPay = (tosPayCancelRequest: ITosPayCancelRequest): Promise<AxiosResponse<ICancelTossPayResponse, any>> => {
    return api.post(`${process.env.REACT_APP_API_DOMAIN}/toss-pay/admin/cancel`, tosPayCancelRequest)
}